export default __webpack_public_path__ + "src/docs/packages/witklipfontein-eco-lodge.pdf";